import { commonInputValidationPattern } from '@/constants/regExp';

class ValidationService {
  public static shouldRestrictInput = (value: string, validationPattern = commonInputValidationPattern) =>
    !validationPattern.test(value);
}

export default ValidationService;
